import Header from '../home/components/Header';
import Footer from '../home/components/Footer';
import SEOHead from '@/components/feature/SEOHead';

const blogSchema = {
  "@context": "https://schema.org",
  "@type": "Blog",
  "name": "Blog Rénovation & Conseils Techniques - CasaReNovaPlus",
  "description": "Guides pratiques, conseils d'experts et actualités sur le chauffage, la ventilation, la plomberie et l'électricité à Genève et en Suisse romande.",
  "url": `${import.meta.env.VITE_SITE_URL}/blog`,
  "publisher": {
    "@type": "Organization",
    "name": "CasaReNovaPlus",
    "url": `${import.meta.env.VITE_SITE_URL}`,
    "logo": {
      "@type": "ImageObject",
      "url": `${import.meta.env.VITE_SITE_URL}/logo.png`
    }
  },
  "inLanguage": "fr-CH"
};

export default function Blog() {
  const articles = [
    {
      id: 1,
      title: "Guide Complet des Pompes à Chaleur à Genève 2024",
      excerpt: "Tout ce que vous devez savoir sur l'installation, l'entretien et les subventions pour les pompes à chaleur air-eau et air-air à Genève. Économies d'énergie garanties jusqu'à 70%.",
      category: "Chauffage",
      date: "15 Mars 2024",
      readTime: "8 min",
      image: "https://readdy.ai/api/search-image?query=modern%20heat%20pump%20installation%20in%20swiss%20home%20with%20professional%20technician%20working%20on%20air%20to%20water%20heating%20system%20in%20clean%20technical%20environment%20with%20tools%20and%20equipment%20showing%20energy%20efficient%20technology&width=800&height=500&seq=blog1&orientation=landscape",
      slug: "guide-pompes-chaleur-geneve-2024"
    },
    {
      id: 2,
      title: "Installation Électrique : Normes et Réglementations Suisses",
      excerpt: "Découvrez les normes NIBT en vigueur pour votre installation électrique à Genève. Mise aux normes, tableau électrique, disjoncteur différentiel, parafoudre et sécurité électrique.",
      category: "Électricité",
      date: "10 Mars 2024",
      readTime: "6 min",
      image: "https://readdy.ai/api/search-image?query=professional%20electrician%20installing%20modern%20electrical%20panel%20with%20circuit%20breakers%20and%20safety%20equipment%20in%20swiss%20building%20following%20technical%20standards%20with%20clean%20organized%20wiring&width=800&height=500&seq=blog2&orientation=landscape",
      slug: "normes-installation-electrique-suisse"
    },
    {
      id: 3,
      title: "Ventilation VMC Double Flux : Économies et Confort",
      excerpt: "La ventilation mécanique contrôlée double flux permet de réduire vos factures de chauffage de 30% tout en améliorant la qualité de l'air intérieur. Guide complet pour Genève.",
      category: "Ventilation",
      date: "5 Mars 2024",
      readTime: "7 min",
      image: "https://readdy.ai/api/search-image?query=modern%20ventilation%20system%20with%20double%20flow%20heat%20recovery%20unit%20installed%20in%20ceiling%20showing%20air%20ducts%20and%20filters%20in%20clean%20technical%20environment%20with%20energy%20efficiency%20indicators&width=800&height=500&seq=blog3&orientation=landscape",
      slug: "vmc-double-flux-economies-confort"
    },
    {
      id: 4,
      title: "Domotique KNX : Automatisez Votre Maison à Genève",
      excerpt: "Système domotique KNX pour maison connectée : éclairage intelligent, chauffage automatisé, volets roulants, alarme et vidéosurveillance. Confort et économies d'énergie.",
      category: "Domotique",
      date: "1 Mars 2024",
      readTime: "9 min",
      image: "https://readdy.ai/api/search-image?query=smart%20home%20automation%20system%20with%20tablet%20control%20showing%20lighting%20heating%20and%20security%20features%20in%20modern%20swiss%20interior%20with%20connected%20devices%20and%20KNX%20technology&width=800&height=500&seq=blog4&orientation=landscape",
      slug: "domotique-knx-maison-connectee-geneve"
    },
    {
      id: 5,
      title: "Rénovation Salle de Bain : Tendances et Prix à Genève",
      excerpt: "Guide complet pour rénover votre salle de bain : douche italienne, robinetterie design, WC suspendu Geberit, carrelage moderne. Prix et délais pour Genève et environs.",
      category: "Sanitaire",
      date: "25 Février 2024",
      readTime: "10 min",
      image: "https://readdy.ai/api/search-image?query=modern%20luxury%20bathroom%20renovation%20with%20italian%20shower%20walk%20in%20design%20contemporary%20fixtures%20suspended%20toilet%20and%20elegant%20tiling%20in%20clean%20bright%20swiss%20style%20interior&width=800&height=500&seq=blog5&orientation=landscape",
      slug: "renovation-salle-bain-geneve-prix"
    },
    {
      id: 6,
      title: "Entretien Chaudière : Obligations et Conseils Pratiques",
      excerpt: "Entretien annuel obligatoire de votre chaudière gaz ou mazout à Genève. Ramonage, contrôle de combustion, désembouage et maintenance préventive pour éviter les pannes.",
      category: "Maintenance",
      date: "20 Février 2024",
      readTime: "5 min",
      image: "https://readdy.ai/api/search-image?query=professional%20technician%20performing%20boiler%20maintenance%20and%20inspection%20with%20tools%20checking%20gas%20heating%20system%20in%20technical%20room%20with%20safety%20equipment%20and%20diagnostic%20instruments&width=800&height=500&seq=blog6&orientation=landscape",
      slug: "entretien-chaudiere-obligations-geneve"
    },
    {
      id: 7,
      title: "Borne de Recharge Électrique : Installation à Domicile",
      excerpt: "Installez votre wallbox pour véhicule électrique à Genève. Guide complet : puissance, câblage, protection électrique, subventions et coûts d'installation pour voiture électrique.",
      category: "Électricité",
      date: "15 Février 2024",
      readTime: "7 min",
      image: "https://readdy.ai/api/search-image?query=electric%20vehicle%20charging%20station%20wallbox%20installation%20at%20home%20with%20professional%20electrician%20working%20on%20power%20connection%20in%20modern%20garage%20with%20clean%20technical%20setup&width=800&height=500&seq=blog7&orientation=landscape",
      slug: "borne-recharge-electrique-installation-geneve"
    },
    {
      id: 8,
      title: "Plancher Chauffant : Avantages et Installation",
      excerpt: "Le chauffage au sol hydraulique offre un confort optimal et des économies d'énergie. Compatible avec pompe à chaleur. Guide technique pour installation à Genève.",
      category: "Chauffage",
      date: "10 Février 2024",
      readTime: "8 min",
      image: "https://readdy.ai/api/search-image?query=underfloor%20heating%20system%20installation%20showing%20pipes%20and%20manifold%20being%20installed%20in%20floor%20with%20professional%20technician%20working%20in%20clean%20construction%20environment%20with%20technical%20equipment&width=800&height=500&seq=blog8&orientation=landscape",
      slug: "plancher-chauffant-avantages-installation"
    },
    {
      id: 9,
      title: "Détection de Fuite d'Eau : Technologies et Solutions",
      excerpt: "Détection de fuite non destructive à Genève : caméra thermique, gaz traceur, électro-acoustique. Recherche de fuite rapide et précise pour éviter les dégâts des eaux.",
      category: "Sanitaire",
      date: "5 Février 2024",
      readTime: "6 min",
      image: "https://readdy.ai/api/search-image?query=professional%20plumber%20using%20thermal%20camera%20and%20leak%20detection%20equipment%20to%20find%20water%20leak%20in%20wall%20with%20modern%20technology%20and%20diagnostic%20tools%20in%20clean%20technical%20environment&width=800&height=500&seq=blog9&orientation=landscape",
      slug: "detection-fuite-eau-technologies-geneve"
    },
    {
      id: 10,
      title: "Panneaux Solaires Photovoltaïques : Rentabilité à Genève",
      excerpt: "Installation de panneaux solaires à Genève : production électrique, autoconsommation, stockage batterie, subventions cantonales. Calculez votre rentabilité et économies.",
      category: "Électricité",
      date: "1 Février 2024",
      readTime: "9 min",
      image: "https://readdy.ai/api/search-image?query=solar%20panels%20photovoltaic%20installation%20on%20swiss%20house%20roof%20with%20professional%20technicians%20working%20on%20mounting%20system%20in%20sunny%20environment%20showing%20clean%20energy%20technology&width=800&height=500&seq=blog10&orientation=landscape",
      slug: "panneaux-solaires-rentabilite-geneve"
    },
    {
      id: 11,
      title: "Adoucisseur d'Eau : Protégez Vos Installations",
      excerpt: "L'eau calcaire à Genève endommage vos installations. Découvrez les avantages de l'adoucisseur d'eau, osmoseur, filtre anti-tartre pour protéger chaudière, robinetterie et électroménager.",
      category: "Sanitaire",
      date: "25 Janvier 2024",
      readTime: "6 min",
      image: "https://readdy.ai/api/search-image?query=water%20softener%20system%20installation%20with%20professional%20plumber%20working%20on%20filtration%20equipment%20showing%20clean%20technical%20setup%20with%20pipes%20and%20control%20unit%20in%20utility%20room&width=800&height=500&seq=blog11&orientation=landscape",
      slug: "adoucisseur-eau-protection-installations"
    },
    {
      id: 12,
      title: "Thermostat Connecté : Économisez Jusqu'à 30%",
      excerpt: "Thermostat intelligent et régulation connectée pour optimiser votre chauffage à Genève. Contrôle à distance, programmation, détection présence. Économies garanties sur facture énergie.",
      category: "Domotique",
      date: "20 Janvier 2024",
      readTime: "7 min",
      image: "https://readdy.ai/api/search-image?query=smart%20thermostat%20connected%20heating%20control%20system%20on%20wall%20with%20smartphone%20app%20showing%20temperature%20settings%20in%20modern%20swiss%20home%20interior%20with%20clean%20design&width=800&height=500&seq=blog12&orientation=landscape",
      slug: "thermostat-connecte-economies-energie"
    }
  ];

  const categories = ["Tous", "Chauffage", "Électricité", "Sanitaire", "Ventilation", "Domotique", "Maintenance"];

  return (
    <div className="min-h-screen bg-white">
      <SEOHead
        title="Blog Rénovation Neuenegg | Conseils Travaux Suisse Romande - CasaReNovaPlus"
        description="Blog CasaReNovaPlus : guides pratiques, conseils d'experts sur la rénovation, chauffage, ventilation, plomberie et électricité à Neuenegg et en Suisse romande."
        keywords="blog CVSE Genève, conseils chauffage Genève, guide électricité Suisse romande, pompe chaleur blog, VMC double flux guide, domotique KNX conseils"
        canonical={`${import.meta.env.VITE_SITE_URL}/blog`}
        schema={blogSchema}
      />
      <Header />
      
      {/* Hero Section */}
      <section className="relative bg-gradient-to-br from-teal-600 to-teal-800 py-20">
        <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-black/10 to-black/20"></div>
        <div className="relative max-w-7xl mx-auto px-6 lg:px-8 text-center">
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-6">
            Blog CVSE & Conseils Techniques
          </h1>
          <p className="text-xl text-white/90 max-w-3xl mx-auto">
            Guides pratiques, conseils d'experts et actualités sur le chauffage, la ventilation, la plomberie et l'électricité à Genève
          </p>
        </div>
      </section>

      {/* Categories Filter */}
      <section className="bg-gray-50 border-b border-gray-200 sticky top-[72px] z-40">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 py-4">
          <div className="flex flex-wrap gap-3 justify-center">
            {categories.map((category) => (
              <button
                key={category}
                className="px-5 py-2 rounded-full bg-white border-2 border-teal-600 text-teal-600 font-semibold hover:bg-teal-600 hover:text-white transition-all whitespace-nowrap cursor-pointer text-sm"
              >
                {category}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Articles Grid */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {articles.map((article) => (
              <article key={article.id} className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-2xl transition-all duration-300 cursor-pointer group">
                <div className="relative h-56 w-full overflow-hidden">
                  <img 
                    src={article.image} 
                    alt={article.title}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                  />
                  <div className="absolute top-4 left-4">
                    <span className="px-4 py-1.5 bg-teal-600 text-white text-xs font-bold rounded-full">
                      {article.category}
                    </span>
                  </div>
                </div>
                <div className="p-6">
                  <div className="flex items-center gap-4 text-sm text-gray-500 mb-3">
                    <span className="flex items-center gap-1">
                      <i className="ri-calendar-line"></i>
                      {article.date}
                    </span>
                    <span className="flex items-center gap-1">
                      <i className="ri-time-line"></i>
                      {article.readTime}
                    </span>
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-3 group-hover:text-teal-600 transition-colors">
                    {article.title}
                  </h3>
                  <p className="text-gray-600 text-sm leading-relaxed mb-4">
                    {article.excerpt}
                  </p>
                  <a 
                    href={`/blog/${article.slug}`}
                    className="inline-flex items-center gap-2 text-teal-600 font-semibold hover:gap-3 transition-all whitespace-nowrap cursor-pointer text-sm"
                  >
                    Lire l'article
                    <i className="ri-arrow-right-line"></i>
                  </a>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* Newsletter Section */}
      <section className="py-16 bg-gradient-to-br from-teal-600 to-teal-800">
        <div className="max-w-4xl mx-auto px-6 lg:px-8 text-center">
          <h2 className="text-3xl font-bold text-white mb-4">
            Restez Informé des Dernières Actualités
          </h2>
          <p className="text-white/90 mb-8 text-lg">
            Recevez nos conseils d'experts, guides pratiques et offres exclusives directement dans votre boîte mail
          </p>
          <form className="flex flex-col sm:flex-row gap-4 max-w-xl mx-auto">
            <input
              type="email"
              placeholder="Votre adresse email"
              className="flex-1 px-6 py-3.5 rounded-full border-2 border-white/20 bg-white/10 text-white placeholder-white/60 focus:outline-none focus:border-white text-sm"
              required
            />
            <button
              type="submit"
              className="px-8 py-3.5 bg-white text-teal-600 rounded-full font-semibold hover:bg-gray-100 transition-colors whitespace-nowrap cursor-pointer text-sm"
            >
              S'abonner
            </button>
          </form>
        </div>
      </section>

      <Footer />
    </div>
  );
}
